// Make button float after scrolling 300px (adjust this value)
const SCROLL_THRESHOLD = 300; // Change this number to control when button floats

window.addEventListener('scroll', function() {
  const button = document.querySelector('.kickflip-customize-button');
  
  if (button && window.innerWidth <= 768) {
    if (window.scrollY > SCROLL_THRESHOLD) {
      button.classList.add('floating');
    } else {
      button.classList.remove('floating');
    }
  }
});
